import { linkify } from './linkify/linkify';

export const normalizeUrl = (url: string) => {
  const result = url && linkify.match(url) && linkify.match(url)?.[0];

  if (result && ['http:', 'https:', ''].includes(result.schema)) {
    return result.url;
  }

  return null;
};
